import styled from 'styled-components';

const StyledNoAccessPage = styled.div`
  margin: 0 320px 0 240px;
  padding: 40px;
`;

export default StyledNoAccessPage;
